/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import Container from "../components/Container";
import NavigationHeader from "../components/NavigationHeader";
import {usePreparedProducts} from "../hooks/usePreparedProducts";
import ProductsCategoriesList from "../components/booking/product/ProductsCategoriesList";
import {FlowType, setFlow} from "../store/slices/flowSlice";
import Icon from "../components/ui/Icon";
import EmptyView from "../components/EmptyView";
import {useStepManager} from "../hooks/useStepManager";
import { useCart } from "../hooks/useCart";
import { useSelectedCategory } from "../hooks/useSelectedCategory";

const ProductsForSaleCategories = () => {
  const selectedCategory = useSelectedCategory();
  const { isLoading, categoriesWithProducts } = usePreparedProducts({ forSale: true });
  const { navigateToNextStep } = useStepManager();
  const dispatch = useDispatch();
  const location = useLocation();
  const { setEntryRoute } = useCart();

  useEffect(() => {
    dispatch(setFlow(FlowType.CART));
    setEntryRoute(location.pathname);
  }, [dispatch, setEntryRoute, location.pathname]);

  useEffect(() => {
    if (selectedCategory) {
      navigateToNextStep();
    }
  }, [selectedCategory]);

  return (
    <Container>
      <NavigationHeader title="Products" cart clientLogin navigation />

      {isLoading || categoriesWithProducts.length > 0
        ? <ProductsCategoriesList isLoading={isLoading} categories={categoriesWithProducts}/>
        : <EmptyView
            icon={Icon.Products}
            title="No categories available"
            description="Please go back and choose another one or contact the company"
          />
      }
    </Container>
  );
};

export default ProductsForSaleCategories;
